/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { getDrupalImageUrl } from "../../api/about/aboutapi";

interface HeroProps {
  data: any;
}

const AboutHero: React.FC<HeroProps> = ({ data}) => {
  const node = data.data;

  /** Collect included images */
  const included = data?.included || [];

  // 📌 Featured image URL
  const featuredId = node?.relationships?.field_featured_image?.data?.id;
  const featuredUrl = getDrupalImageUrl(featuredId, included);

  // 📌 Gallery Images
  const galleryIds = node?.relationships?.field_gallery_images?.data || [];
  const galleryUrls = galleryIds
    .map((g: any) => getDrupalImageUrl(g.id, included))
    .filter(Boolean);

  //console.log(galleryUrls);
  return (

      <section id="hero" className="hero section about-hero dark-background about-banner">
            {featuredUrl && (
              <img
                src={featuredUrl}
                loading="lazy"
                className="hero-bg d-xl-block d-lg-block d-md-block d-sm-none w-100"
                alt=""
              />
            )}
            {galleryUrls?.[0] && (
              <img  src={galleryUrls?.[0]}
                loading="lazy"
                className="hero-bg d-xl-none d-lg-none d-md-none  d-sm-block w-100"
                alt=""
              />
            )}
            <div className="container">
                <div className="row gy-4  justify-content-between">

                    <div className="col-xl-6 col-lg-6 col-md-6 d-flex flex-column text-md-start text-sm-center justify-content-center" data-aos="fade-in">
                         <label className="about-title banner-h1">{node.attributes.field_description}</label>

            <p className="about-title-para" dangerouslySetInnerHTML={{ __html:node.attributes.field_content.value }} />

            {/* <ul data-aos="slide-up">
              {data?.field_title?.map((item: any, i: number) => (
                <li key={i}>
                  <small>{item?.value}</small>
                </li>
              ))}
            </ul> */}
                       
                        
                    </div>
                    {/* <div className="col-lg-6  hero-img">
                        <div className="text-end">
                            <img src={aboutImg2?.thumbnail?.[0]?.url} className="img-fluid " alt="" data-aos="slide-left" data-aos-delay="100" />
                        </div>
                    </div> */}

                </div>
            </div>


        </section>
  );
};

export default React.memo(AboutHero);